<template>
  <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 gap-2">
    <ul class="space-y-2">
      <li
        v-for="rentalListingAgreementLandlord in rentalListingAgreement.relationships.rentalListingAgreementLandlords.data"
        :key="rentalListingAgreementLandlord.id"
      >
        <!-- prevent row click when customer link is clicked -->
        <CustomerLink :customer="rentalListingAgreementLandlord" class="pl-4" @click.stop />
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    <ul class="space-y-2">
      <li
        v-for="rentalListingAgreementProperty in rentalListingAgreement.relationships.rentalListingAgreementProperties.data"
        :key="rentalListingAgreementProperty.id"
      >
        {{ rentalListingAgreementProperty.relationships.property.data.attributes.fullAddress }}
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    {{ rentalListingAgreement.attributes.commission }} {{ rentalListingAgreement.relationships.commissionType.data?.attributes?.name }}
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    {{ parseDate(rentalListingAgreement.attributes.endAt) }}
  </td>

  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
    <div class="flex justify-left space-x-2 pr-4">
      <!-- prevent row click on action icons -->
      <router-link
        class="text-indigo-600 hover:text-indigo-900 transition-transform duration-200 hover:scale-110"
        :to="{ name: 'rental-listing-agreement', params: { id: rentalListingAgreement.id } }"
        @click.stop
      >
        <MagnifyingGlassIcon class="size-5" aria-hidden="true" />
      </router-link>

      <router-link
        class="text-indigo-600 hover:text-indigo-900 transition-transform duration-200 hover:scale-110"
        :to="{ name: 'edit-rental-listing-agreement', params: { id: rentalListingAgreement.id } }"
        @click.stop
      >
        <PencilSquareIcon class="size-5" aria-hidden="true" />
      </router-link>
    </div>
  </td>
</template>

<script setup>
import CustomerLink from "@/components/customers/CustomerLink.vue";
import { PencilSquareIcon, MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { useDate } from "@/utils/stores/date";

const { parseDate } = useDate();

const props = defineProps({
  rentalListingAgreement: Object,
});

const rentalListingAgreement = props.rentalListingAgreement;
</script>
